import { Form } from 'antd';
import DefaultDrawer from '../defaultDrawer/DefaultDrawer';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import ChangePasswordForm from '../../../forms/changePassword/ChangePasswordForm';
import { useModal } from '../../../../contexts/modalsContext/modalsContext';
import { changePassword } from '../../../../../services/customer/profileServices';
import { ReactComponent as GRLogo } from '../../../../../resources/images/svg/GRLogo.svg';
import formSetDynamicErrors from '../../../../../utils/functions/formSetDynamicErrors';
import useTranslation from '../../../../hooks/translation/useTranslation';

function ChangePasswordDrawer() {
  const { trans, configInfo } = useTranslation();
  const { width } = useWindowDimensions();
  const { showChangePasswordModal, setShowChangePasswordModal } = useModal();
  const [form] = Form.useForm();

  const handleSubmit = async (values) => {
    try {
      const res = await changePassword(values);
      if (res.status === 'success') {
        setShowChangePasswordModal(false);
        form.resetFields();
      }
    } catch (e) {
      formSetDynamicErrors({
        e, form, trans,
      });
    }
  };

  const isGeorgia = configInfo?.countryCode === 'GE';

  return (
    <DefaultDrawer
      placement="bottom"
      setShow={setShowChangePasswordModal}
      show={showChangePasswordModal && width < 1024}
      className="gray-after auth-drawer media"
      style={{ backgroundColor: '#f1f2f6' }}
      title={(
        <div className="flex items-center justify-between pr-10 xsm:pr-5">
          {isGeorgia ? <GRLogo />
            : (
              <img
                src="/ticketLogos/mobileLogoArm.png"
                alt="Armenia Railway Logo"
                width={90}
                height={42}
              />
            )}
        </div>
  )}
    >
      <ChangePasswordForm
        handleSubmit={handleSubmit}
        form={form}
      />
    </DefaultDrawer>
  );
}

export default ChangePasswordDrawer;
